let windowScrollPos = 0;


function _vwSP(size, base = 768) {
  windowWidth = window.innerWidth;
  return (size / base) * windowWidth;
}

function _vwPC(size, base = 1920) {
  windowWidth = window.innerWidth;
  return (size / base) * windowWidth;
}



// ------------------------------------------------------------------------
// スムーススクロール
// ------------------------------------------------------------------------
const smoothScroll = () => {
  $('a[href^="#"]').on('click.smoothScroll', function() {
    let linkSpeed    = 400;
    let linkHref     = $(this).attr('href');
    let linkTarget   = $(linkHref == '#' || linkHref == '' ? 'html' : linkHref);
    let linkPosition = linkTarget.offset().top;
    let linkAdjust   = 0;
    $('html, body').animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, 'swing');
    return false;
  });
};



// ------------------------------------------------------------------------
// YouTube動画モーダル表示
// ------------------------------------------------------------------------
const showYouTubeModal = () => {
  //スムーススクロール無効
  $('[data-trigger="youtube_modal"]').on('mouseenter', function() {
    $(this).off('click.smoothScroll');
  });


  $('[data-trigger="youtube_modal"]').on('click', function() {
    let youtubeID = $(this).attr('data-youtube-id');
    let html = '';

    //背景コンテンツ固定
    windowScrollPos = $(window).scrollTop();
    $('body').addClass('fixed').css({'top': -windowScrollPos});

    //iframe設定
    html = '<iframe src="https://www.youtube.com/embed/' + youtubeID + '?autoplay=1" width="800" height="450" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
    $('.sw-YouTube_Modal .video_inner').append(html);

    //モーダルボックス表示
    $('.sw-YouTube_Modal').fadeIn(300);

    return false;
  });


  // ---------- 閉じる ---------- //
  function modalClose() {
    //背景コンテンツ固定解除
    $('body').removeClass('fixed').css({'top': ''});
    $(window).scrollTop(windowScrollPos);

    //モーダルボックス非表示
    $('.sw-YouTube_Modal').fadeOut(200);

    //コンテンツ破棄
    setTimeout(function() {
      $('.sw-YouTube_Modal .video_inner').html('');
    }, 300);
  }

  $('.sw-YouTube_Modal .btn_close').on('click', function() {
    modalClose();
    return false;
  });

  $('.sw-YouTube_Modal').on('click', function() {
    modalClose();
    return false;
  });
}



export {
  smoothScroll,
  showYouTubeModal,
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js